<template>
  <v-container>
    <template v-if="this.$route.query.usergroup">
      <v-col
        :class="{
          'get-lower': !$vuetify.breakpoint.mdAndUp,
          'pa-0': true,
          fullScreen: true,
          fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
        }"
        cols="12"
      >
        <DialogForMassOperators
          :dialog.sync="dialogDelete"
          :loading.sync="loading"
          :head-text="$t('user.remove-title')"
          :content-text="$t('user.remove-dialog')"
          :confirm-button="{
            text: $t('user.remove'),
            icon: 'mdi-trash-can-outline'
          }"
          :selected.sync="selected"
          v-on:update:selected="updateSelected"
          permission="user_group.delete"
          dispatch="userStore/deleteList"
          :on-success="updateUserGroupList"
          permissions-item-key="_user_groups"
        ></DialogForMassOperators>
        <v-toolbar dense flat>
          <v-toolbar-title>{{ $t("user-groups.user-groups") }}</v-toolbar-title>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              v-for="item in menu"
              :key="item.title"
              :to="item.to"
              text
              color="primary"
              :disabled="item.disabled"
              v-on:click="item.onClick()"
              ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-col>
          <v-row>
            <v-col cols="7" sm="11">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$i18n.t('user-groups.search-label')"
                single-line
                hide-details
                clearable
                class="pa-0 ma-0"
              ></v-text-field>
            </v-col>
            <v-col cols="5" sm="1" class="reset">
              <v-btn v-on:click="$router.push({ name: 'UserGroups' })" block>
                <v-icon>
                  mdi-filter-remove-outline
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <CommonTable
          :can-add="canAdd"
          :can-delete="canDelete"
          list-getter="userStore/getList"
          :headers="headers"
          :slots="slots"
          resource="user"
          @updated="updateUserGroupList"
          :loading.sync="loading"
          :create-item-callback="addUser"
          :delete-item-callback="deleteUser"
          show-select
          v-on:update:selected="updateSelected"
          :selected.sync="selected"
        ></CommonTable>
        <Paginator page-getter="userStore/getPage"></Paginator>
        <v-divider />
      </v-col>
    </template>
    <template v-else>
      <div>
        <h3>{{ $t("user-groups.group-not-selected") }}</h3>
      </div>
    </template>
  </v-container>
</template>

<script>
import { rules } from "./../components/mixins/rules";
import CommonTable from "../components/common/tables/CommonTable";
import Paginator from "../components/common/tables/Paginator";
import { permissions } from "../components/mixins/permissions";
import debounce from "../assets/js/debounce";

import DialogForMassOperators from "../components/common/dialogs/DialogForMassOperators";
import { title } from "../components/mixins/title";
import api from "../store/utils/api";
import {
  createErrorMessage,
  createSuccessMessage
} from "../store/utils/service";
export default {
  name: "User",
  mixins: [rules, permissions, title],
  components: {
    CommonTable,
    Paginator,
    DialogForMassOperators
  },
  data: function() {
    let limits = {
      25: 25,
      50: 50,
      100: 100,
      200: 200
    };
    return {
      currentPage: +this.$route.query.user_page || 1,
      search: this.$route.query.user_search || "",
      selected: [],
      headers: [
        {
          text: this.$i18n.t("user-groups.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("user-groups.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      userGroup: this.$route.query.userGroup || "",
      limit: limits[this.$route.query.limit_user] || 25,
      limits,
      orders: this.$route.query.orders || "",
      loading: false,
      userToDelete: null,
      dialogDeleteOne: false,
      dialogDelete: false
    };
  },
  computed: {
    slots() {
      return [
        {
          name: "name",
          type: "text",
          title: "email",
          form: {
            type: "text",
            name: "name",
            visible: true
          }
        }
      ];
    },
    menu() {
      let vm = this;
      return [
        {
          title: this.$t("user.remove"),
          to: null,
          onClick: function() {
            vm.dialogDelete = true;
          },
          disabled: !this.isSomeSelectedCanBeDelete,
          icon: "mdi-trash-can-outline"
        }
      ];
    },
    isSomeSelectedCanBeDelete() {
      return !!this.selected.find(i =>
        this.hasPermissions(i._user_group, "user_group.delete")
      );
    },
    isHaveGroup() {
      return this.$route.query && this.$route.query.usergroup;
    },
    canDelete: {
      get() {
        return this.hasPermissions("user.remove");
      }
    },
    canAdd: {
      get() {
        return this.hasPermissions("user.create");
      }
    },
    ordersName() {
      if (this.orders) {
        return this.orders.split(":")[0];
      } else {
        return "";
      }
    },
    ordersIsDesc() {
      if (this.orders) {
        return this.orders.split(":")[1] === "desc";
      }
      return false;
    },
    page: {
      get() {
        return this.$store.getters["userStore/getPage"];
      }
    }
  },
  watch: {
    search() {
      this.startQueryForSearch();
    },
    currentPage(val) {
      this.$router.push({
        name: "User",
        query: { ...this.$route.query, user_page: val }
      });
    },
    "$route.query.usergroup": function() {
      this.updateUserGroupList();
    },
    "$route.query.user_search": function() {
      this.updateParams();
    },
    "$route.query.limit_user": function() {
      this.updateParams();
    },
    "$route.query.orders": function() {
      this.updateParams();
    }
  },
  methods: {
    updateParams() {
      this.selected = [];
      this.userGroup = this.$route.query.userGroup || "";
      this.currentPage = +this.$route.query.user_page || 1;
      this.search = this.$route.query.user_search || "";
      this.orders = this.$route.query.orders || "";
      this.limit = this.limits[this.$route.query.limit_user] || 25;
      this.updateUserGroupList();
    },
    addUser(name) {
      const id = this.$route.query.usergroup;
      const userEmail = name.name;

      return api
        .put(`/user-groups/${id}/members`, { email: userEmail })
        .then(() => {
          createSuccessMessage("add");
          this.loading = false;
          this.updateUserGroupList();
        })
        .catch(error => {
          createErrorMessage(error);
        });
    },
    deleteUser(member_id) {
      const id = this.$route.query.usergroup;
      return api
        .delete(`/user-groups/${id}/members/${member_id}`)
        .then(() => {
          createSuccessMessage("delete");
          this.loading = false;
          this.updateUserGroupList();
        })
        .catch(res => createErrorMessage(res));
    },
    updateSelected(val) {
      this.$set(this.$data, "selected", val);
    },
    setUserToDelete(user = null) {
      this.userToDelete = user;
      this.dialogDeleteOne = !!user;
    },
    deleteMultiUser() {
      this.dialogDeleteOne = false;
      this.loading = true;
      this.userToDelete.isWillRemoveSoon = true;
      this.$store.dispatch("userStore/deleteList", {
        id: this.userToDelete.id,
        onSuccess: () => {
          this.selected = this.selected.filter(
            i => i.id !== this.userToDelete.id
          );
          this.updateUserGroupList();
          this.setUserToDelete();
        },
        onError: () => {
          this.userToDelete.isWillRemoveSoon = false;
          this.setUserToDelete();
        }
      });
    },
    updateUserGroupList() {
      if (this.isHaveGroup) {
        this.selected = [];
        let orders = "";
        if (this.orders) {
          let order = this.ordersIsDesc ? "desc" : "asc";
          if (this.ordersName === "name") {
            orders += `name:${order}`;
          } else {
            orders += this.ordersName + ":" + order;
          }
        }
        this.loading = true;
        let params = {
          orders,
          id: this.$route.query.usergroup,
          page: this.currentPage,
          limit: this.limit,
          filters: {
            userGroup: this.userGroup,
            name: this.search
          }
        };
        this.$store.dispatch("userStore/getList", {
          params,

          onSuccess: () => {
            this.loading = false;
          }
        });
      }
    },
    startQueryForSearch: debounce(function() {
      let query = {
        ...this.$route.query,
        user_page: 1
      };
      if (this.search) {
        query.user_search = this.search;
      } else {
        delete query.user_search;
      }
      this.$router.push({
        name: "UserGroups",
        query
      });
    }, 500),

    customSort(items, index, isDesc) {
      if (index && index[0]) {
        let newOrders = index[0] + ":" + (isDesc[0] ? "desc" : "asc");
        if (newOrders !== this.$route.query.orders)
          this.$router.push({
            name: "UserGroups",
            query: {
              ...this.$route.query,
              orders: newOrders
            }
          });
      } else {
        let query = { ...this.$route.query };
        if (query.orders) {
          delete query.orders;
          this.$router.push({
            name: "UserGroups",
            query
          });
        }
      }
      return items;
    },

    getArgumentForTitle() {
      return {
        chain: [this.$t("user-groups.user-groups")]
      };
    }
  },
  mounted() {
    this.updateUserGroupList();
  }
};
</script>
<style lang="scss" scoped>
.no-break {
  white-space: nowrap;
}
.smaller {
  transform: scale(0.8, 0.8);
}
.get-lower {
  margin-top: 25px;
}
.data-table::v-deep td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.data-table.theme--light.v-data-table::v-deep
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: rgb(225, 74, 74);
}
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreen .data-table {
  flex: 1 1 100%;
  overflow: hidden;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
.fullScreenMobile::v-deep .v-data-table__mobile-row {
  height: auto;
  .v-data-table__mobile-row__wrapper {
    align-items: flex-start;
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .no-break {
    display: flex;
    flex-direction: row-reverse;
  }
}
.fullScreenMobile::v-deep .v-data-table-header-mobile th {
  padding-right: 0;
  padding-left: 12px;
  .v-data-table-header-mobile__wrapper {
    flex-direction: row-reverse;
  }
  div.active .v-data-table-header__icon {
    opacity: 1;
  }
}
.fullScreen::v-deep .v-input--selection-controls__ripple {
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
